import React, { useEffect } from 'react';
import { useFormContext, Controller, FieldErrors } from 'react-hook-form';
import {
  createStyles,
  FormControl,
  TextField,
  MenuItem,
  FormHelperText,
  InputLabel,
  makeStyles,
  Theme,
  withStyles
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Select, { OptionProps } from 'react-select';
import { TSelectItem } from '../../../types/common';

type TProps = {
  name: any;
  listDatas: TSelectItem[];
  style?: any;
  onChange?: any;
  defaultValue?: TSelectItem;
  required?: boolean;
  error?: boolean;
  helperText?: string;
  fullWidth?: boolean;
  label?: string;
  value?: TSelectItem;
  validate?: any;
};

export const AppSelectfield: React.VFC<TProps> = React.memo((props: TProps) => {
  // react-hook-fomrを使用する前提のcomponent
  const { register, control } = useFormContext();
  const height = 34;

  const classes = useStyles();

  // https://mui.com/components/text-fields/#main-content の必要なpropsを追加する
  const {
    name,
    listDatas,
    style,
    onChange,
    defaultValue,
    required = false,
    error,
    helperText,
    fullWidth = false,
    label,
    value
  } = props;

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <Autocomplete
          {...register(name, {
            required: required,
            validate: value => {
              if (required) {
                return value.value != 0;
              }
              return true;
            }
          })}
          {...field}
          options={listDatas}
          autoHighlight
          classes={{
            inputRoot: classes.inputRoot // class name, e.g. `classes-nesting-root-x`
          }}
          className={classes.textField}
          fullWidth={fullWidth}
          getOptionLabel={option => option.label}
          defaultValue={defaultValue}
          value={field.value?.value === 0 ? null : field.value}
          style={style}
          onChange={(_, value) => {
            field.onChange(value);

            if (onChange) {
              onChange(value);
            }
          }}
          renderInput={params => (
            <TextField
              {...params}
              placeholder={label}
              autoComplete='off'
              helperText={helperText}
              error={error}
              variant='outlined'
              inputProps={{
                ...params.inputProps,
                autoComplete: 'new-password',
                style: {
                  height,
                  padding: '0 14px'
                }
              }}
            />
          )}
        />
      )}
    />
  );
});

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    textField: {
      backgroundColor: 'white',
      zIndex: 11
    },
    inputRoot: {
      padding: '0px !important'
    }
  })
);
